import script from "./ProductNutritionalSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductNutritionalSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductNutritionalSkeleton.vue?vue&type=style&index=0&id=4a1d3b10&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a1d3b10"]])

export default __exports__